import { render, staticRenderFns } from "./ChatShopeeHistory.vue?vue&type=template&id=cb36dab8&scoped=true&"
import script from "./ChatShopeeHistory.vue?vue&type=script&lang=js&"
export * from "./ChatShopeeHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatShopeeHistory.vue?vue&type=style&index=0&id=cb36dab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb36dab8",
  null
  
)

export default component.exports